import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/ocr/ocrIngestion';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	/** @namespace state.lists.ocrIngestionIds **/
	/** @namespace state.maps.ocrIngestion **/
	/** @namespace state.maps.user **/
	let ocrIngestions;
	if (state.lists.ocrIngestionIds) {
		ocrIngestions = _.map(state.lists.ocrIngestionIds, (id) => state.maps.ocrIngestion[id]);
	}

	return {
		ocrIngestions,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		ocrIngestionDocumentMap: state.maps.ocrIngestionDocument,
		ocrGuideMap: state.maps.ocrGuide,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			ocrIngestionSearch: search,
			ocrIngestionRemove: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
